import { FULFILLMENT_TYPE, STATUS_CODE, CANCELLATION_STATUS, } from '../../../constants/status';
// TODO: Add more logics based on the requirements
//  Please define the fulfillment and status on status file do not use a direct string value.
// Some of the Self-Serive Buttons are not eligible for B2B account
export var getOrderStatus = function (statusCode) {
    var isProcessing = statusCode === STATUS_CODE.PROCESSING;
    var isShipped = statusCode === STATUS_CODE.SHIPPED;
    var isBackOrdered = statusCode === STATUS_CODE.BACKORDERED;
    var isInTransit = statusCode === STATUS_CODE.IN_TRANSIT;
    var isDeliveryAttempted = statusCode === STATUS_CODE.ATTEMPTED;
    var isDelivered = statusCode === STATUS_CODE.DELIVERED;
    var isOnItsWayToStore = statusCode === STATUS_CODE.ON_ITS_WAY_TO_STORE;
    var isOutForDelivery = statusCode === STATUS_CODE.OUT_FOR_DELIVERY;
    var isDFSOnSchedule = statusCode === STATUS_CODE.DFS_ON_SCHEDULE;
    var isArrivedAtStore = statusCode === STATUS_CODE.PREPARING_FOR_PICKUP;
    var isReadyForPickup = statusCode === STATUS_CODE.READY_FOR_PICKUP;
    var isOrderPickedup = statusCode === STATUS_CODE.COMPLETED;
    var isOrderCompleted = statusCode === STATUS_CODE.COMPLETED;
    var isReturnStarted = statusCode === STATUS_CODE.RETURN_IN_PROGRESS;
    var isReturned = statusCode === STATUS_CODE.RETURNED;
    var isCanceled = statusCode === STATUS_CODE.CANCELED;
    var isMAOnSchedule = statusCode === STATUS_CODE.MAJOR_APPLIANCE_ON_SCHEDULE;
    var isBOSSArrivedAndPickedUp = isArrivedAtStore || isReadyForPickup || isOrderPickedup;
    var isBODFSOnSchedule = statusCode === STATUS_CODE.BODFS_ON_SCHEDULE;
    var isStatusDeliveredOrOutForDelivery = isDelivered || isOutForDelivery;
    var isStatusDeliveredOrOrderPickedup = isDelivered || isOrderCompleted;
    var isArrivedAtStoreAndReadyForPickup = isArrivedAtStore || isReadyForPickup;
    /** for `MA`, `BODFS` and `DFS` orders */
    var isProcessingOrOnSchedule = isProcessing || isMAOnSchedule || isBODFSOnSchedule || isDFSOnSchedule;
    var isCancelledOrReturn = isCanceled || isReturned || isReturnStarted;
    return {
        isProcessing: isProcessing,
        isShipped: isShipped,
        isBackOrdered: isBackOrdered,
        isInTransit: isInTransit,
        isDeliveryAttempted: isDeliveryAttempted,
        isDelivered: isDelivered,
        isOutForDelivery: isOutForDelivery,
        isDFSOnSchedule: isDFSOnSchedule,
        isOnItsWayToStore: isOnItsWayToStore,
        isArrivedAtStore: isArrivedAtStore,
        isReadyForPickup: isReadyForPickup,
        isOrderCompleted: isOrderCompleted,
        isReturnStarted: isReturnStarted,
        isReturned: isReturned,
        isCanceled: isCanceled,
        isMAOnSchedule: isMAOnSchedule,
        isStatusDeliveredOrOutForDelivery: isStatusDeliveredOrOutForDelivery,
        isStatusDeliveredOrOrderPickedup: isStatusDeliveredOrOrderPickedup,
        isBOSSArrivedAndPickedUp: isBOSSArrivedAndPickedUp,
        isArrivedAtStoreAndReadyForPickup: isArrivedAtStoreAndReadyForPickup,
        isBODFSOnSchedule: isBODFSOnSchedule,
        isProcessingOrOnSchedule: isProcessingOrOnSchedule,
        isCancelledOrReturn: isCancelledOrReturn,
    };
};
export var getFulfillmentStatus = function (fulfillmentType) {
    var isSTH = fulfillmentType === FULFILLMENT_TYPE.STH;
    var isBOSS = fulfillmentType === FULFILLMENT_TYPE.BOSS;
    var isBOPIS = fulfillmentType === FULFILLMENT_TYPE.BOPIS;
    var isMA = fulfillmentType === FULFILLMENT_TYPE.MA;
    var isBODFS = fulfillmentType === FULFILLMENT_TYPE.BODFS;
    var isDFS = fulfillmentType === FULFILLMENT_TYPE.DFS;
    var isMisc = fulfillmentType === FULFILLMENT_TYPE.MISC;
    var isEligibleFulfillmentAAFESOrNex = isMA;
    var isFulfillmentSTHorBOSS = isSTH || isBOSS;
    var isFulfillmentBODFSorDFS = isBODFS || isDFS;
    var isFulfillmentMAorBODFSorDFS = isMA || isFulfillmentBODFSorDFS; // Reschedule Eligible
    var isFulfillmentCurbsideEligible = isBOSS || isBOPIS;
    var isFulfillmentReturnEligible = isFulfillmentSTHorBOSS;
    var isFulfillmentMethodExcludeBOPIS = isFulfillmentSTHorBOSS || isFulfillmentBODFSorDFS || isMA; // for order Tracking
    return {
        isSTH: isSTH,
        isBOSS: isBOSS,
        isBOPIS: isBOPIS,
        isMA: isMA,
        isBODFS: isBODFS,
        isDFS: isDFS,
        isMisc: isMisc,
        isFulfillmentSTHorBOSS: isFulfillmentSTHorBOSS,
        isFulfillmentBODFSorDFS: isFulfillmentBODFSorDFS,
        isFulfillmentMAorBODFSorDFS: isFulfillmentMAorBODFSorDFS,
        isFulfillmentMethodExcludeBOPIS: isFulfillmentMethodExcludeBOPIS,
        isFulfillmentCurbsideEligible: isFulfillmentCurbsideEligible,
        isFulfillmentReturnEligible: isFulfillmentReturnEligible,
        isEligibleFulfillmentAAFESOrNex: isEligibleFulfillmentAAFESOrNex,
    };
};
// TODO: ADD MISC TYPE OF FULFILLMENT once B2B and B2C APi is figured out
export var getOrderActionEligibility = function (fulfillmentType, statusCode) {
    var orderStatus = getOrderStatus(statusCode);
    var orderFulfillment = getFulfillmentStatus(fulfillmentType);
    var isBOPIS = orderFulfillment.isBOPIS, isFulfillmentSTHorBOSS = orderFulfillment.isFulfillmentSTHorBOSS, isFulfillmentMAorBODFSorDFS = orderFulfillment.isFulfillmentMAorBODFSorDFS, isFulfillmentCurbsideEligible = orderFulfillment.isFulfillmentCurbsideEligible, isEligibleFulfillmentAAFESOrNex = orderFulfillment.isEligibleFulfillmentAAFESOrNex;
    var isProcessing = orderStatus.isProcessing, isShipped = orderStatus.isShipped, isBackOrdered = orderStatus.isBackOrdered, isReturnStarted = orderStatus.isReturnStarted, isDelivered = orderStatus.isDelivered, isDeliveryAttempted = orderStatus.isDeliveryAttempted, isArrivedAtStore = orderStatus.isArrivedAtStore, isOutForDelivery = orderStatus.isOutForDelivery, isReadyForPickup = orderStatus.isReadyForPickup, isOrderCompleted = orderStatus.isOrderCompleted, isStatusDeliveredOrOutForDelivery = orderStatus.isStatusDeliveredOrOutForDelivery, isOnItsWayToStore = orderStatus.isOnItsWayToStore, isArrivedAtStoreAndReadyForPickup = orderStatus.isArrivedAtStoreAndReadyForPickup, isBODFSOnSchedule = orderStatus.isBODFSOnSchedule, isProcessingOrOnSchedule = orderStatus.isProcessingOrOnSchedule;
    var isCancelEligibleForSTHorBOSS = isFulfillmentSTHorBOSS && (isProcessing || isBackOrdered); // for both remorse and post remorse
    var isRescheduleEligibleForMAorBODFSorDFS = isFulfillmentMAorBODFSorDFS && isProcessingOrOnSchedule; // On Schedule for MA, BODFS and DFS order
    var isPrintReturnAvailable = isFulfillmentSTHorBOSS && isReturnStarted;
    var isTrackingPrimaryForMAandBODFSandDFS = isFulfillmentMAorBODFSorDFS && isDelivered; // primary button for ma,bodfs and dfs for delivered order
    var isCurbsideEligible = isFulfillmentCurbsideEligible && (isReadyForPickup || isArrivedAtStore);
    var isTrackShipmentAvailable = ((isFulfillmentSTHorBOSS || isFulfillmentMAorBODFSorDFS) &&
        (isShipped || isStatusDeliveredOrOutForDelivery)) ||
        isTrackingPrimaryForMAandBODFSandDFS;
    var fulfillmentTypeEligibleForReturn = isFulfillmentSTHorBOSS &&
        (isShipped ||
            isDelivered ||
            isReadyForPickup ||
            isOrderCompleted ||
            isOnItsWayToStore ||
            isArrivedAtStore);
    var isBopisCancelEligible = isBOPIS && !isOrderCompleted;
    var isBopisArrivedAndReadyForPickUp = isArrivedAtStoreAndReadyForPickup;
    var isMAorBODFSorDFSCancelEligible = isFulfillmentMAorBODFSorDFS && !isOrderCompleted;
    var isTrackingEligibleForFulfillmentMethod = !isBOPIS;
    var isTrackingPrimaryForMAorBODFSorDFS = isFulfillmentMAorBODFSorDFS &&
        (isOutForDelivery ||
            isShipped ||
            isDeliveryAttempted ||
            isDelivered ||
            isBODFSOnSchedule);
    var isTrackingPrimaryForSTHorBOSS = isFulfillmentSTHorBOSS &&
        (isShipped || isOnItsWayToStore || isArrivedAtStore) &&
        !isCurbsideEligible;
    return {
        isCancelEligibleForSTHorBOSS: isCancelEligibleForSTHorBOSS,
        isPrintReturnAvailable: isPrintReturnAvailable,
        isTrackingPrimaryForMAandBODFSandDFS: isTrackingPrimaryForMAandBODFSandDFS,
        isCurbsideEligible: isCurbsideEligible,
        isTrackShipmentAvailable: isTrackShipmentAvailable,
        fulfillmentTypeEligibleForReturn: fulfillmentTypeEligibleForReturn,
        isRescheduleEligibleForMAorBODFSorDFS: isRescheduleEligibleForMAorBODFSorDFS,
        isBopisCancelEligible: isBopisCancelEligible,
        isMAorBODFSorDFSCancelEligible: isMAorBODFSorDFSCancelEligible,
        isBopisArrivedAndReadyForPickUp: isBopisArrivedAndReadyForPickUp,
        isTrackingEligibleForFulfillmentMethod: isTrackingEligibleForFulfillmentMethod,
        isTrackingPrimaryForMAorBODFSorDFS: isTrackingPrimaryForMAorBODFSorDFS,
        isTrackingPrimaryForSTHorBOSS: isTrackingPrimaryForSTHorBOSS,
        isEligibleFulfillmentAAFESOrNex: isEligibleFulfillmentAAFESOrNex,
    };
};
// Looks through a list of fulfillment groups and returns true if the target fulfillment type exists
export var doesFulfillmentStatusExist = function (targetFulfillmentType, fulfillmentGroups) {
    return fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.some(function (group) { return group.fulfillmentType === targetFulfillmentType; });
};
export var isBopisOutOfStockRecoverable = function (fulfillmentGroup) {
    var _a, _b, _c;
    return (fulfillmentGroup.cancellationStatus === CANCELLATION_STATUS.OUT_OF_STOCK &&
        ((_a = fulfillmentGroup.actions) === null || _a === void 0 ? void 0 : _a.isOosRecoveryEnabled) &&
        ((_c = (_b = fulfillmentGroup.oosRecoveryOptions) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0);
};
